import { BoumRight } from '@moia-dev/moia-token-claims'

export const AUTOMATIONS_RIGHTS = [
  BoumRight.WORK_ORDERS_AUTOMATIONS_CRUD,
  BoumRight.WORK_ORDERS_AUTOMATIONS_R,
]

export const AUTOMATION_ID_SEARCH_PARAM = 'id'
